/* Hero slider — stacked slides with a sweep / fade / slide transition plus
   drag-to-swipe.

   The sweep is two nested transforms: an outer mask slides in from the edge
   while the image inside counter-moves, so the picture reads as standing
   still while it gets uncovered.

   Movement uses the Web Animations API rather than CSS transitions, which
   depend on the browser committing an intermediate style recalculation and
   are fragile when an element is revealed and moved in the same task. */
(function () {
  'use strict';

  function boot() {
    document.querySelectorAll('[data-hero-sweep]').forEach(function (el) {
      if (el.dataset.heroReady === '1') return;
      el.dataset.heroReady = '1';
      init(el);
    });
  }

  function init(root) {
    var stage = root.querySelector('.hero__stage');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.hero__slide'));
    if (!stage || slides.length === 0) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('.hero__dot'));
    var effect = root.dataset.effect || 'sweep';
    var duration = parseInt(root.dataset.duration || '900', 10);
    var easing = root.dataset.ease || 'cubic-bezier(.65,0,.35,1)';
    var autoplay = root.dataset.autoplay === 'true';
    var speed = parseInt(root.dataset.speed || '6', 10) * 1000;
    var canDrag = root.dataset.drag !== 'false';
    var hold = parseInt(root.dataset.hold || '88', 10);

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var dur = reduced ? 1 : duration;

    var index = 0;
    var busy = false;
    var timer = null;
    var running = [];

    function reveal(s) { return s.querySelector('.hero__reveal'); }
    function media(s) { return s.querySelector('.hero__media'); }

    /* p = 0 hidden, 1 fully shown. dir 1 = arrives from the right. */
    function maskAt(dir, p) { return 'translateX(' + (dir * (100 - p * 100)) + '%)'; }
    function imageAt(dir, p) { return 'translateX(' + (-dir * hold * (1 - p)) + '%)'; }

    function paint(s, dir, p) {
      if (effect === 'fade') { s.style.opacity = String(p); return; }
      if (effect === 'slide') { s.style.transform = maskAt(dir, p); return; }
      var r = reveal(s), m = media(s);
      if (r) r.style.transform = maskAt(dir, p);
      if (m) m.style.transform = imageAt(dir, p);
    }

    function stopAnims() {
      running.forEach(function (a) { try { a.cancel(); } catch (e) {} });
      running = [];
    }

    function move(el, to, prop) {
      if (!el) return null;
      var kf = prop === 'opacity' ? [{ opacity: to }] : [{ transform: to }];
      var a = el.animate(kf, { duration: dur, easing: easing, fill: 'forwards' });
      running.push(a);
      return a;
    }

    function park(s, dir) {
      s.classList.remove('is-active');
      s.style.zIndex = 0;
      s.style.visibility = 'hidden';
      s.style.opacity = effect === 'fade' ? '0' : '1';
      if (effect !== 'slide') s.style.transform = 'none';
      paint(s, dir || 1, 0);
    }

    function present(s) {
      s.classList.add('is-active');
      s.style.zIndex = 2;
      s.style.visibility = 'visible';
      s.style.opacity = '1';
      if (effect !== 'slide') s.style.transform = 'none';
      paint(s, 1, 1);
    }

    function settle() {
      stopAnims();
      slides.forEach(function (s, i) {
        if (i === index) present(s); else park(s, 1);
        s.setAttribute('aria-hidden', String(i !== index));
      });
      busy = false;
    }

    function paintDots(n) {
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === n);
        var fill = d.querySelector('.hero__dot-fill');
        if (!fill) return;
        if (fill.getAnimations) fill.getAnimations().forEach(function (a) { a.cancel(); });
        fill.style.transform = 'scaleX(0)';
        if (i === n && autoplay && !reduced) {
          fill.animate([{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }],
                       { duration: speed, easing: 'linear', fill: 'forwards' });
        }
      });
    }

    function go(next, dir) {
      next = (next + slides.length) % slides.length;
      if (busy || next === index || slides.length < 2) return;
      busy = true;
      stopAnims();

      var outgoing = slides[index];
      var incoming = slides[next];

      incoming.style.visibility = 'visible';
      incoming.style.zIndex = 3;
      outgoing.style.zIndex = 2;
      paint(incoming, dir, 0);

      var last;
      if (effect === 'fade') {
        last = move(incoming, '1', 'opacity');
        move(outgoing, '0', 'opacity');
      } else if (effect === 'slide') {
        last = move(incoming, maskAt(dir, 1));
        move(outgoing, 'translateX(' + (-dir * 100) + '%)');
      } else {
        last = move(reveal(incoming), maskAt(dir, 1));
        move(media(incoming), imageAt(dir, 1));
      }

      incoming.classList.add('is-active');
      outgoing.classList.remove('is-active');

      index = next;
      paintDots(index);

      if (last) last.addEventListener('finish', settle, { once: true });
      else settle();
      window.setTimeout(function () { if (busy) settle(); }, dur + 120);
    }

    function nextSlide() { go(index + 1, 1); }
    function prevSlide() { go(index - 1, -1); }

    function start() { if (autoplay && slides.length > 1 && !timer) timer = window.setInterval(nextSlide, speed); }
    function stop() { window.clearInterval(timer); timer = null; }
    function bump() { stop(); start(); }

    if (canDrag && slides.length > 1) {
      var x0 = null, y0 = null, partner = null, dir = 0, axis = null;
      var width = function () { return stage.offsetWidth || 1; };

      stage.addEventListener('pointerdown', function (e) {
        if (busy || e.button > 0) return;
        x0 = e.clientX; y0 = e.clientY; axis = null; partner = null;
        stop();
      });

      stage.addEventListener('pointermove', function (e) {
        if (x0 === null || busy) return;
        var dx = e.clientX - x0, dy = e.clientY - y0;

        if (axis === null) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        }
        if (axis !== 'x') return;
        e.preventDefault();

        var d = dx < 0 ? 1 : -1;
        if (partner === null || d !== dir) {
          if (partner) park(partner, dir || 1);
          dir = d;
          partner = slides[(index + dir + slides.length) % slides.length];
          partner.style.visibility = 'visible';
          partner.style.zIndex = 3;
          paint(partner, dir, 0);
        }
        paint(partner, dir, Math.min(Math.abs(dx) / width(), 1));
      }, { passive: false });

      var release = function (e) {
        if (x0 === null) return;
        var dx = ((e.clientX == null) ? x0 : e.clientX) - x0;
        var p = Math.abs(dx) / width();
        var target = partner;
        var commit = axis === 'x' && target && p > 0.18;
        x0 = null; y0 = null; partner = null; axis = null;

        if (commit) {
          busy = true;
          var outgoing = slides[index];
          var last;
          if (effect === 'fade') { last = move(target, '1', 'opacity'); move(outgoing, '0', 'opacity'); }
          else if (effect === 'slide') { last = move(target, maskAt(dir, 1)); move(outgoing, 'translateX(' + (-dir * 100) + '%)'); }
          else { last = move(reveal(target), maskAt(dir, 1)); move(media(target), imageAt(dir, 1)); }

          target.classList.add('is-active');
          outgoing.classList.remove('is-active');
          index = (index + dir + slides.length) % slides.length;
          paintDots(index);
          if (last) last.addEventListener('finish', settle, { once: true });
          window.setTimeout(function () { if (busy) settle(); }, dur + 120);
        } else if (target) {
          var last2;
          if (effect === 'fade') last2 = move(target, '0', 'opacity');
          else if (effect === 'slide') last2 = move(target, maskAt(dir, 0));
          else { last2 = move(reveal(target), maskAt(dir, 0)); move(media(target), imageAt(dir, 0)); }
          if (last2) last2.addEventListener('finish', function () { stopAnims(); park(target, 1); }, { once: true });
        }
        start();
      };

      stage.addEventListener('pointerup', release);
      stage.addEventListener('pointercancel', release);
      stage.addEventListener('pointerleave', release);
      stage.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }

    var nx = root.querySelector('[data-hero-next]');
    var pv = root.querySelector('[data-hero-prev]');
    if (nx) nx.addEventListener('click', function () { nextSlide(); bump(); });
    if (pv) pv.addEventListener('click', function () { prevSlide(); bump(); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i, i > index ? 1 : -1); bump(); }); });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () { return document.hidden ? stop() : start(); });

    index = 0;
    settle();
    paintDots(0);
    start();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Re-init when a section is re-rendered in the theme editor. */
  document.addEventListener('shopify:section:load', boot);
})();
